module.exports = __webpack_public_path__ + "static/img/logo.6b92bb70.png";